import { RequestConfig } from '~/common/services/requests';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { REPORT_BASE_PATH } from '../constants/reportBasePath';

export const generateReport = async (
  constructGet: ConstructGet,
  type: string,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructGet<NonPaginatedResponse<null>>(
    `${REPORT_BASE_PATH}/${type}/generate`,
    { params },
  );
